export default __webpack_public_path__ + "LNGSelectedPin.png";